(() => {
  'use strict';
  const MAX_BYTES = 50 * 1024 * 1024;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const get = name => root.querySelector(`[data-${name}]`);
    const input = get('files'), list = get('list'), status = get('status'), error = get('error');
    const merge = get('merge'), clear = get('clear'), sheet = get('new-sheet'), result = get('result'), download = get('download');
    let items = [], busy = false, outputUrl = '', outputFile = null;
    const share = get('share'), shareHint = get('share-hint');
    const size = bytes => bytes < 1024 * 1024 ? `${Math.max(1,Math.ceil(bytes / 1024))} KB` : `${(bytes / 1024 / 1024).toLocaleString('nl-NL', {maximumFractionDigits:1})} MB`;
    const fail = message => { error.textContent = message; error.hidden = false; };
    function invalidate() {
      result.hidden = true;
      outputFile = null;
      share.hidden = shareHint.hidden = true;
      download.textContent = 'Download je pdf';
      download.removeAttribute('href');
      if (outputUrl) URL.revokeObjectURL(outputUrl);
      outputUrl = '';
    }
    function render() {
      list.replaceChildren();
      items.forEach((item, index) => {
        const li = document.createElement('li'), info = document.createElement('div');
        info.className = 'dp-merge__file-info';
        const name = document.createElement('strong'), details = document.createElement('small');
        name.textContent = `${index + 1}. ${item.file.name}`;
        details.textContent = `${item.pages} ${item.pages === 1 ? 'pagina' : 'pagina’s'} · ${size(item.file.size)}`;
        info.append(name, details);
        const controls = document.createElement('div');
        controls.className = 'dp-merge__file-controls';
        [['up','↑','Omhoog',index === 0],['down','↓','Omlaag',index === items.length - 1],['remove','×','Verwijder',false]].forEach(([action, icon, label, disabled]) => {
          const button = document.createElement('button');
          button.type = 'button'; button.textContent = icon; button.title = label;
          button.setAttribute('aria-label', `${label}: ${item.file.name}`);
          button.disabled = busy || disabled;
          button.addEventListener('click', () => {
            invalidate(); error.hidden = true;
            const destination = action === 'up' ? index - 1 : index + 1;
            if (action === 'remove') items.splice(index,1);
            else [items[index],items[destination]] = [items[destination],items[index]];
            render();
            const target = list.children[Math.min(action === 'remove' ? index : destination, items.length - 1)]?.querySelector(`button[title="${label}"]`);
            (target && !target.disabled ? target : input).focus();
          });
          controls.append(button);
        });
        li.append(info,controls); list.append(li);
      });
      input.disabled = sheet.disabled = busy;
      merge.disabled = busy || items.length < 2;
      clear.disabled = busy || !items.length;
      root.querySelector('.dp-merge__tool').setAttribute('aria-busy',String(busy));
      if (!busy) status.textContent = items.length ? `${items.length} bestanden · ${items.reduce((sum,item) => sum + item.pages,0)} pagina’s · ${size(items.reduce((sum,item) => sum + item.file.size,0))}. ${items.length < 2 ? 'Kies nog minimaal één pdf.' : 'Controleer de volgorde en klik op Samenvoegen.'}` : 'Kies minimaal twee pdf’s om te beginnen.';
    }
    input.addEventListener('change',async () => {
      const files = Array.from(input.files || []); input.value = '';
      if (!files.length || busy) return;
      error.hidden = true;
      if (!window.PDFLib) { fail('De pdf-hulp kon niet worden geladen. Vernieuw de pagina en probeer opnieuw.'); return; }
      if (items.length + files.length > 25) { fail('Kies maximaal 25 pdf-bestanden. Verwijder eerst een bestand om een ander toe te voegen.'); return; }
      if (items.reduce((sum,item) => sum + item.file.size,0) + files.reduce((sum,file) => sum + file.size,0) > MAX_BYTES) { fail('De bestanden zijn samen groter dan 50 MB. Kies kleinere pdf’s.'); return; }
      busy = true; render();
      const additions = [];
      try {
        for (const file of files) {
          status.textContent = `Controleren: ${file.name}`;
          if (!/\.pdf$/i.test(file.name)) throw new Error(`“${file.name}” is geen pdf-bestand. Kies alleen pdf’s.`);
          let doc;
          try { doc = await PDFLib.PDFDocument.load(await file.arrayBuffer()); }
          catch { throw new Error(`“${file.name}” kan niet worden gelezen. Gebruik een geldige pdf zonder wachtwoord.`); }
          if (!doc.getPageCount()) throw new Error(`“${file.name}” bevat geen pagina’s.`);
          additions.push({file,pages:doc.getPageCount()});
          if ([...items,...additions].reduce((sum,item) => sum + item.pages,0) > 1000) throw new Error('Voeg maximaal 1.000 pagina’s tegelijk samen.');
        }
        items.push(...additions); invalidate();
      } catch (cause) { fail(cause.message); }
      finally { busy = false; render(); }
    });
    share.addEventListener('click', async () => {
      if (!outputFile || share.disabled) return;
      share.disabled = true;
      error.hidden = true;
      try {
        // Call directly from the user's click, before awaiting anything.
        await navigator.share({files:[outputFile]});
        window.location.assign('/');
      } catch (cause) {
        if (cause.name === 'AbortError') status.textContent = 'Bewaren gesloten. Je kunt opnieuw op Bewaar je pdf klikken.';
        else fail('Het bewaarmenu kon niet worden geopend. Probeer opnieuw of gebruik de downloadlink.');
      } finally { share.disabled = false; }
    });
    sheet.addEventListener('change',invalidate);
    clear.addEventListener('click',() => { items = []; invalidate(); error.hidden = true; render(); input.focus(); });
    merge.addEventListener('click',async () => {
      if (busy || items.length < 2) return;
      busy = true; error.hidden = true; invalidate(); render();
      try {
        const output = await PDFLib.PDFDocument.create();
        for (let i = 0; i < items.length; i++) {
          status.textContent = `Samenvoegen: bestand ${i + 1} van ${items.length}…`;
          await new Promise(resolve => setTimeout(resolve,0));
          const doc = await PDFLib.PDFDocument.load(await items[i].file.arrayBuffer());
          // Preserve printable values of interactive form fields in the merged document.
          const form = doc.getForm();
          if (form.getFields().length) form.flatten();
          if (sheet.checked && output.getPageCount() % 2) {
            const previous = output.getPages()[output.getPageCount() - 1];
            output.addPage([previous.getWidth(),previous.getHeight()]).setRotation(previous.getRotation());
          }
          const pages = await output.copyPages(doc,doc.getPageIndices());
          pages.forEach(page => output.addPage(page));
        }
        output.setTitle('pdfprinter-samengevoegd');
        const bytes = await output.save();
        if (bytes.length > MAX_BYTES) throw new Error('SIZE');
        outputUrl = URL.createObjectURL(new Blob([bytes],{type:'application/pdf'}));
        download.href = outputUrl;
        outputFile = new File([bytes], 'pdfprinter-samengevoegd.pdf', {type:'application/pdf'});
        let canSave = false;
        try { canSave = !!navigator.share && !!navigator.canShare?.({files:[outputFile]}); } catch { /* Use the download link when file sharing is unavailable. */ }
        share.hidden = shareHint.hidden = !canSave;
        if (canSave) download.textContent = 'Of download je pdf';
        get('result-info').textContent = `${output.getPageCount()} pagina’s · ${size(bytes.length)}. De paginagrootte en richting zijn behouden.`;
        result.hidden = false; (share.hidden ? download : share).focus();
      } catch (cause) { fail(cause.message === 'SIZE' ? 'De nieuwe pdf is groter dan 50 MB. Voeg minder of kleinere bestanden samen.' : 'Samenvoegen is niet gelukt. Controleer of je pdf’s zonder wachtwoord goed openen. Probeer de bestanden eventueel in kleinere groepen.'); }
      finally { busy = false; render(); if (!result.hidden) status.textContent = 'Klaar. Download en controleer je nieuwe pdf.'; }
    });
    // Keep the object URL alive while Safari opens or downloads the PDF.
    // It is released when a new result replaces it, or by the browser on document disposal.
    render();
  }
  document.querySelectorAll('[data-pdf-merge]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-pdf-merge]').forEach(init));
})();